import React, { useEffect, useRef, useState } from "react";
import { Show, SimpleShowLayout, TextField, useNotify, useRecordContext } from "react-admin";
import { Box } from "@material-ui/core";
import { hostname } from "../../providers/api";
import { useTokenOps } from "../../components/TokenContext";
import DppSection from "./DppSection";
import sections from "./sections";
import { LoadingState, ErrorState } from "./states";

const DppSections = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const notifyRef = useRef(notify);
  notifyRef.current = notify;

  const tokenOps = useTokenOps();
  const accountId = tokenOps?.account?.data?.accountId;
  const accessToken = tokenOps?.account?.accessToken;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dppResponse, setDppResponse] = useState(null);

  const articleId = record?.id || null;

  useEffect(() => {
    if (!articleId) return;
    if (!accountId || !accessToken) {
      const msg = "Missing account context — re-authenticate or pick an account.";
      setError(msg);
      notifyRef.current(msg, "warning");
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetch(`${hostname}/articles/${accountId}/${articleId}/dpp`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error fetching DPP: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (!cancelled) setDppResponse(data || null);
      })
      .catch((err) => {
        if (cancelled) return;
        const message = err.message || "Error fetching DPP";
        setError(message);
        notifyRef.current(message, "error");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [articleId, accountId, accessToken]);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} />;
  if (!dppResponse) return null;

  const dpp = dppResponse?.dpp_compliance || null;
  const article = dppResponse?.article || null;

  return (
    <Box style={{ marginTop: 16 }}>
      {sections.map((section) => (
        <DppSection key={section.key} header={section.header}>
          {section.render(dpp, article, dppResponse)}
        </DppSection>
      ))}
    </Box>
  );
};

const ArticleDppShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Article" />
      <TextField source="reference" label="Reference" />
      <TextField source="collection" label="Collection" />
      <DppSections />
    </SimpleShowLayout>
  </Show>
);

export default ArticleDppShow;
